import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSearchlinesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSearchlinesSparkle"><Path fillRule="evenodd" clipRule="evenodd" d="M20 13.9824L19.4307 12.5H16.5693L15.4395 15.4395L12.5 16.5693V19.4307L15.4395 20.5596L15.9932 22H4V2H20V13.9824ZM7 10.5H12V9H7V10.5ZM7 6.5H15V5H7V6.5Z" fill="currentColor"/><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSearchlinesSparkle;
